import { defineComponent } from "vue";

import { PAGE_NAME } from "./attributes";
import { SettingsTabValue } from "./model";
import { RoutesName } from "@/shared/constants/enums";

import {
  SettingsTabs,
  SettingsKycKyb,
  SettingsRequisites,
} from "@/components/pages/settings";

type Component = typeof SettingsKycKyb | typeof SettingsRequisites;

export default defineComponent({
  name: PAGE_NAME,
  components: {
    SettingsTabs,
    SettingsKycKyb,
    SettingsRequisites,
  },
  data() {
    return {
      tab: SettingsTabValue.requisites,
      userRepo: this.$projectServices.userRepo,
    };
  },
  computed: {
    displayedComponent(): Component {
      switch (this.tab) {
        case SettingsTabValue["kyc-kyb"]:
          return SettingsKycKyb;
        case SettingsTabValue.requisites:
          return SettingsRequisites;
        default:
          return SettingsRequisites;
      }
    },
  },
  methods: {
    tabChange(tabValue: SettingsTabValue): void {
      if (
        tabValue === SettingsTabValue["kyc-kyb"] &&
        !this.userRepo.isVerified
      ) {
        this.$router.push({ name: RoutesName.verification });
        return;
      }

      this.tab = tabValue;
    },
  },
});
